import { useNavigate } from 'react-router-dom';

import apiToken, {
  handleApiError,
  isSuccess,
} from '@/shared/services/axiosInstance';

import { SignUpForm } from '../types/SignUpTypes';

interface useSubmitProps {
  signupForm: SignUpForm;
}

export const useSubmit = ({ signupForm }: useSubmitProps) => {
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    if (e) e.preventDefault();

    try {
      const response = await apiToken.post('/api/v1/auth/signup', signupForm);
      if (isSuccess(response.data)) {
        // 회원가입 성공
        alert('Sign up successful! Please log in.');
        navigate('/login');
      }
    } catch (error) {
      const errorMessage = handleApiError(error);
      console.error('Failed to sign up:', errorMessage);
    }
  };
  return { handleSubmit };
};
